var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackbin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.777778H7.5L6.78571 0H3.21429L2.5 0.777778H0V2.33333H10M0.714286 12.4444C0.714286 12.857 0.864795 13.2527 1.1327 13.5444C1.40061 13.8361 1.76398 14 2.14286 14H7.85714C8.23602 14 8.59939 13.8361 8.8673 13.5444C9.1352 13.2527 9.28571 12.857 9.28571 12.4444V3.11111H0.714286V12.4444Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackbin);
export default __webpack_public_path__ + "static/media/blackbin.59330c7a14fcf97a5d00c60fb8cb2777.svg";
export { ForwardRef as ReactComponent };